import { format } from "date-fns";
import { useState } from "react";
import { Card, TextField, Text, CopyTextField } from "@merge-api/merge-javascript-shared";
import clsx from "clsx";

const getFormattedDate = (dateString: string | undefined) => {
  if (!dateString) {
    return undefined;
  }

  try {
    var now = undefined;

    // Check if it's a unix timestamp
    if (typeof dateString == "string" && dateString.match("[0-9]+")?.[0] == dateString) {
      const unixTimestamp = parseInt(dateString);
      now = new Date(unixTimestamp * 1000);
    } else {
      now = new Date(dateString);
    }

    return format(
      new Date(now.getTime() + now.getTimezoneOffset() * 60000),
      "yyyy-MM-dd'T'HH:mm:ss'Z'"
    );
  } catch {
    return undefined;
  }
};

const MappingTestEditorLeftPanelUtilsSubtab = () => {
  const [timestampValue, setTimestampValue] = useState<string>();
  const formattedDate = getFormattedDate(timestampValue);

  return (
    <div className="flex flex-col gap-y-6">
      <TextField
        labelTitle="Timestamp converter"
        labelSubtitle="Enter a timestamp to see the formatted date"
        id="timestamp"
        onChange={(e) => setTimestampValue(e.target.value)}
        placeholder="Enter timestamp"
        value={timestampValue}
      />

      <Card
        variant="outline"
        className={clsx(
          "transition-all duration-300 ease-in-out overflow-hidden",
          formattedDate ? "h-auto p-3" : "h-0 border-0"
        )}
      >
        <Text variant="h6" className="mb-2">
          Formatted timestamp
        </Text>
        <CopyTextField text={formattedDate ?? "Enter a value to see the formatted date"} />
      </Card>
    </div>
  );
};

export default MappingTestEditorLeftPanelUtilsSubtab;
